<template>
  <modal :show.sync="comEdit">
    <h4 slot="header" class="title title-up">
      {{ $t("app.modules.messages.edit.title") }}
    </h4>

    <ValidationObserver ref="formEditCom" v-slot="{ handleSubmit }">
      <form
        @submit.prevent="handleSubmit(submitEditMessage)"
        id="formEditCom"
        name="formEditCom"
      >
        <div class="row">
          <div class="col-sm-12">
            <ValidationProvider
              name="minLength"
              rules="required|min:2"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                :error="failed ? $t('app.validation.min_length') + '2' : null"
                :hasSuccess="passed"
                name="minLength"
                :label="$t('app.modules.messages.headers.name')"
                v-model="item.nombreComunicacion"
              >
              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <ValidationProvider
              name="required"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <fg-input
                :error="failed ? $t('app.validation.required') : null"
                :hasSuccess="passed"
                name="required"
                :label="$t('app.modules.messages.headers.ini_date')"
              >
                <el-date-picker
                  type="date"
                  placeholder="Date Picker"
                  v-model="item.fechaInicio"
                >
                </el-date-picker>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <ValidationProvider
              name="required"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <fg-input
                :error="failed ? $t('app.validation.required') : null"
                :hasSuccess="passed"
                name="required"
                :label="$t('app.modules.messages.headers.end_date')"
              >
                <el-date-picker
                  type="date"
                  placeholder="Date Picker"
                  v-model="item.fechaFin"
                >
                </el-date-picker>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4">
            {{ $t("app.modules.messages.headers.public") }} <br />

            <n-switch v-model="item.tipoUsuarioVisualizar"></n-switch>
          </div>

          <div class="col-sm-4">
            {{ $t("app.general.active") }} <br />

            <n-switch v-model="item.activo"></n-switch>
          </div>

          <div class="col-sm-4 form-group has-label">
            <label>{{
              $t("app.modules.order_entry_schedule.headers.order_category")
            }}</label>
            <template>
              <el-select
                class="select-danger"
                placeholder="Single Select"
                v-model="item.tipoComunicado_idTipoComunicado"
              >
                <el-option
                  v-for="option in types"
                  class="select-danger"
                  :value="option.id"
                  :label="option.text"
                  :key="option.id"
                >
                </el-option>
              </el-select>
            </template>
          </div>
        </div>

        <div clas="row">
          <b>{{ $t("app.translations") }}</b>
          <div
            class="col-sm-12"
            v-for="lang in item.langs"
            :key="lang.idioma_idIdioma"
          >
            <b>{{ lang.idioma }}</b>
            <ValidationProvider
              name="minLength"
              rules="required|min:2"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                :error="failed ? $t('app.validation.min_length') + '2' : null"
                :hasSuccess="passed"
                name="minLength"
                :label="$t('app.modules.messages.add.text')"
                v-model="lang.textoComunicacion"
              >
              </fg-input>
            </ValidationProvider>
            <ValidationProvider
              name="minLength"
              rules="required|min:2"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                :error="failed ? $t('app.validation.min_length') + '2' : null"
                :hasSuccess="passed"
                name="minLength"
                :label="$t('app.modules.messages.add.link')"
                v-model="lang.enlaceComunicacion"
              >
              </fg-input>
            </ValidationProvider>
            <template>
              <card style="width: 20rem;">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="server  + lang.imagenComunicacion"
                  :preview-src-list="[server + lang.imagenComunicacion]"
                >
                </el-image>
                <p class="card-text">
                  {{ $t("app.modules.messages.headers.current_image") }}
                </p>
              </card>
            </template>
            <el-upload
              class="upload-demo"
              ref="upload"
              action="#"
              :name="lang.idioma_idIdioma"
              :on-change="handleFile"
              :auto-upload="false"
            >
              <n-button
                slot="trigger"
                size="small"
                type="primary"
                :id="lang.idioma_idIdioma"
                @click.native="onClick"
                >{{ $t("app.upload.select_file") }}</n-button
              >
              <div class="el-upload__tip" slot="tip">
                {{ $t("app.upload.image_size_limit") }}
              </div>
            </el-upload>
          </div>
        </div>

        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px; border-top: outset"
          class="text-right"
        >
          <n-button
            class="pull-left btn-secondary"
            @click.native="cancelAdd()"
            >{{ $t("app.buttons.cancel") }}</n-button
          >
          <n-button native-type="submit" type="primary">{{
            $t("app.buttons.save")
          }}</n-button>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";

export default {
  components: {},
  data() {
    return {
      server: "",
      types: [
        {
          id: 1,
          text: this.$t("app.modules.messages.types.promo")
        },
        {
          id: 2,
          text: this.$t("app.modules.messages.types.advice")
        },
        {
          id: 3,
          text: this.$t("app.modules.messages.types.bulletin")
        }
      ],
      item: {
        idComunicacion: 0,
        nombreComunicacion: "",
        fechaInicio: new Date(),
        fechaFin: new Date(),
        tipoUsuarioVisualizar: false,
        fechaRegistro: new Date(),
        tipoComunicado_idTipoComunicado: 0,
        activo: false,
        langs: []
      },
      file: {},
      files: [],
      comEdit: false,
      datePickerModal: false,
      currLang: 0,
      typeSelected: 0,
      currText: "",
      currLink: ""
    };
  },
  computed: {
    ...mapState(["availableLangs"])
  },
  created() {
    this.item.langs = [];
    this.server = process.env.VUE_APP_API_ENDPOINT;
  },
  mounted() {
    EventBus.$on("comunicados-edit", async item => {
      this.item.idComunicacion = item.idComunicacion;
      this.item.comunicacion_idComunicacion = item.comunicacion_idComunicacion;
      this.item.nombreComunicacion = item.nombreComunicacion;
      this.item.fechaInicio = item.fechaInicio;
      this.item.fechaFin = item.fechaFin;
      this.item.tipoUsuarioVisualizar = item.tipoUsuarioVisualizar;
      this.item.fechaRegistro = item.fechaRegistro;
      this.item.tipoComunicado_idTipoComunicado =
        item.tipoComunicado_idTipoComunicado;
      this.item.activo = item.activo;
      await this.initEditMessage();
      console.log(this.item);
      this.comEdit = true;
    });
  },
  methods: {
    async initEditMessage() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      var datas = {
        id: this.item.comunicacion_idComunicacion,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario
      };
      await this.$http
        .post(route("Comunicaciones/getTraduccionesComunicaciones"), datas)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.item.langs = response.body.traducciones;
              console.log(this.item);
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            console.log(error);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
      this.$swal.close();
    },
    cancelAdd() {
      this.$refs.formEditCom.reset();
      this.comEdit = false;
    },
    async submitEditMessage() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.editMessage();
      this.$swal.close();
    },
    async editMessage() {
      const params = {
        Id: 0,
        ClaveIdioma: this.$store.lang,
        Usuario: this.$store.Id,
        Comunicacion: this.item
      };
      await this.$http
        .put(route("Comunicaciones/updateComunicado"), params)
        .then(
          async response => {
            if (response.body.code === 200) {
              console.log(response.body);
              this.notifyMessage("success", this.$t("app.promps.save_success"));
              for (let lang of this.item.langs) {
                console.log(lang);
                let formData = new FormData();
                formData.append(
                  "IdComunicacionTraduccion",
                  lang.idComunicacionTraduccion
                );
                formData.append("ImagenComunicacion", lang.imagenComunicacion);
                formData.append("file", lang.imagenComunicacionFile);
                formData.append("Idioma_idIdioma", lang.idioma_idIdioma);
                formData.append("TextoComunicacion", lang.textoComunicacion);
                formData.append("EnlaceComunicacion", lang.enlaceComunicacion);
                formData.append(
                  "Comunicacion_idComunicacion",
                  lang.comunicacion_idComunicacion
                );
                await this.$http
                  .post(
                    route("Comunicaciones/postUpdateComunicacionTraduccion"),
                    formData,
                    {
                      headers: {
                        "Content-Type": "multipart/form-data"
                      }
                    }
                  )
                  .then(
                    async responseTraduccion => {
                      if (response.body.code === 200) {
                        /*this.notifyMessage(
                          "success",
                          this.$t("app.promps.save_success")
                        );*/
                      } else {
                        this.notifyMessage(
                          "danger",
                          this.$t("app.promps.error")
                        );
                      }
                    },
                    error => {
                      this.notifyMessage("danger", this.$t("app.promps.error"));
                    }
                  )
                  .finally(() => {});
              }
              this.cancelAdd();
              EventBus.$emit("reload-promos");
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    handleFile(file) {
      const index = this.item.langs.findIndex(
        l => l.idioma_idIdioma.toString() == this.currLang.toString()
      );
      console.log(this.currLang);
      console.log(index);
      if (index != undefined && index > -1) {
        Vue.set(this.item.langs, index, {
          idComunicacionTraduccion: this.item.langs[index]
            .idComunicacionTraduccion,
          idioma_idIdioma: this.currLang,
          idioma: "",
          comunicacion_idComunicacion: 0,
          imagenComunicacionFile: file.raw,
          imagenComunicacion: this.item.langs[index].imagenComunicacion,
          textoComunicacion: this.item.langs[index].textoComunicacion,
          enlaceComunicacion: this.item.langs[index].enlaceComunicacion,
          comunicacion_idComunicacion: this.item.langs[index]
            .comunicacion_idComunicacion
        });
      }
      console.log(this.item.langs);
    },
    onClick: function(e) {
      var clickedElement = e.target;
      console.log(clickedElement.id);
      this.currLang = clickedElement.id;
    }
  }
};
</script>
